import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', icon: '🏠', label: 'Главная' },
  { path: '/finances', icon: '💰', label: 'Финансы' },
  { path: '/health', icon: '🏥', label: 'Здоровье' },
  { path: '/family', icon: '👨‍👩‍👧‍👦', label: 'Семья' },
  { path: '/goals', icon: '🎯', label: 'Цели' },
  { path: '/balance', icon: '◉', label: 'Баланс' },
  { path: '/faq', icon: '❓', label: 'FAQ' },
  { path: '/news', icon: '📰', label: 'Новости' },
  { path: '/install', icon: '📲', label: 'Установить приложение' },
];
interface MobileHeaderProps {
  userName?: string;
  onLogout: () => void;
  onAIClick?: () => void;
  userRole?: 'user' | 'admin';
  onAdminClick?: () => void;
}
export const MobileHeader: React.FC<MobileHeaderProps> = ({ userName, onLogout, onAIClick, userRole, onAdminClick }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const trigger = useRef<HTMLButtonElement>(null), drawer = useRef<HTMLDivElement>(null);
  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!open) return;
    const panel = drawer.current;
    const opener = trigger.current;
    panel?.querySelector<HTMLButtonElement>('button')?.focus();
    const keydown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); setOpen(false); }
      if (e.key === 'Tab') {
        const controls = panel?.querySelectorAll<HTMLElement>('a[href], button:not([disabled])');
        if (!controls?.length) return;
        const first = controls[0], last = controls[controls.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', keydown);
    return () => { document.removeEventListener('keydown', keydown); opener?.focus(); };
  }, [open]);
  return <>
    <header className="mobile-header mobile-app-header">
      <button ref={trigger} type="button" className="mobile-header-button" aria-label="Открыть меню" aria-expanded={open} aria-controls="mobile-navigation" onClick={() => setOpen(true)}>☰</button>
      <div className="mobile-brand"><h1>🚀 Avatar</h1><p>{userName || 'Пользователь'}</p></div>
      <button type="button" id="ai-assistant-header-button" className="mobile-header-button" aria-label="AI-помощник" onClick={onAIClick}>🤖</button>
    </header>
    {open && <div className="mobile-nav-overlay" onClick={() => setOpen(false)}>
      <div ref={drawer} id="mobile-navigation" role="dialog" aria-modal="true" aria-labelledby="mobile-menu-title" className="mobile-nav-drawer" onClick={e => e.stopPropagation()}>
        <div className="mobile-nav-heading"><div><strong id="mobile-menu-title">Разделы Avatar</strong><p>{userName || 'Пользователь'}</p></div><button type="button" aria-label="Закрыть меню" onClick={() => setOpen(false)}>✕</button></div>
        <nav aria-label="Разделы приложения">{navItems.map(item => <Link key={item.path} to={item.path} aria-current={location.pathname === item.path ? 'page' : undefined} onClick={() => setOpen(false)}><span aria-hidden="true">{item.icon}</span>{item.label}</Link>)}</nav>
        <div className="mobile-nav-footer">
          {userRole === 'admin' && <button type="button" onClick={() => { setOpen(false); onAdminClick?.(); }}>👑 Админка</button>}
          <button type="button" onClick={() => { setOpen(false); onLogout(); }}>🚪 Выйти</button>
        </div>
      </div>
    </div>}
  </>;
};
